import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import SideBarContainer from '../SideBarContainer';
import FirmLogo from '../FirmLogo';

const PageContainer = ({children}) => (
  <div className={styles.pageContainer}>
    <SideBarContainer/>
    <div className={styles.contentContainer}>
      <div className={styles.header}>
        <FirmLogo className={styles.mainLogo}/>
      </div>
      <div className={styles.main}>
        {children}
      </div>
    </div>
  </div>
);

PageContainer.propTypes = {
  children: PropTypes.node
};

export default PageContainer;
